/** Must match `projects/atomickit-admin/src/app/auth/auth-sync.messages.ts` and `projects/atomickit-autofiler/src/app/auth/auth-sync.messages.ts`. */
export const AUTH_SYNC_MESSAGE_TYPE = {
  REQUEST: 'atomickit-admin-auth-request',
  DELIVER: 'atomickit-admin-auth-deliver',
} as const;
